import { createI18n } from 'vue-i18n';

import arMA from '@/locale/ar-MA.json';
import arSA from '@/locale/ar-SA.json';
import csCZ from '@/locale/cs-CZ.json';
import deDE from '@/locale/de-DE.json';
import enGB from '@/locale/en-GB.json';
import enUS from '@/locale/en-US.json';
import es419 from '@/locale/es-419.json';
import esES from '@/locale/es-ES.json';
import frFR from '@/locale/fr-FR.json';
import idID from '@/locale/id-ID.json';
import itIT from '@/locale/it-IT.json';
import jaJP from '@/locale/ja-JP.json';
import koKR from '@/locale/ko-KR.json';
import msMY from '@/locale/ms-MY.json';
import plPL from '@/locale/pl-PL.json';
import roRO from '@/locale/ro-RO.json';
import ruRU from '@/locale/ru-RU.json';
import thTH from '@/locale/th-TH.json';
import trTR from '@/locale/tr-TR.json';
import urPK from '@/locale/ur-PK.json';
import viVN from '@/locale/vi-VN.json';
import zhCN from '@/locale/zh-CN.json';
import zhHK from '@/locale/zh-HK.json';
import zhTW from '@/locale/zh-TW.json';

const currentLocale = localStorage.getItem('locale');

const i18n = createI18n({
  locale: currentLocale || 'should-fall-back',
  fallbackLocale: 'en-US',
  messages: {
    'ar-MA': arMA,
    'ar-SA': arSA,
    'cs-CZ': csCZ,
    'de-DE': deDE,
    'en-GB': enGB,
    'en-US': enUS,
    'es-419': es419,
    'es-ES': esES,
    'fr-FR': frFR,
    'id-ID': idID,
    'it-IT': itIT,
    'ja-JP': jaJP,
    'ko-KR': koKR,
    'ms-MY': msMY,
    'pl-PL': plPL,
    'ro-RO': roRO,
    'ru-RU': ruRU,
    'th-TH': thTH,
    'tr-TR': trTR,
    'ur-PK': urPK,
    'vi-VN': viVN,
    'zh-CN': zhCN,
    'zh-HK': zhHK,
    'zh-TW': zhTW
  }
});

export const t = i18n.global.t;

export default i18n;
